<section class="create-course">
  <div class="create-header">
    <h1>Create New Course</h1>
    <p>Add chapters, topics, and duration step-by-step.</p>
  </div>

  <!-- Add First Unit Button -->
  <div *ngIf="!addUnitVisible && savedUnits.length === 0">
    <button class="add-unit-btn primary-btn" (click)="showAddUnit()">
      <i class="bi bi-plus"></i> Add First Unit
    </button>
  </div>
</section>

<!-- Display Saved Units -->
<section class="saved-units" *ngIf="savedUnits.length > 0">
  <p class="units-count">Saved Units: {{ savedUnitsCount }}</p>

  <section class="saved-unit card" *ngFor="let unit of savedUnits; let idx = index">
    <div class="unit-header">
      <h4>Unit {{ idx + 1 }}. {{ unit.unit_title }}</h4>
      <div class="unit-actions">
        <button type="button" class="edit-btn" (click)="editUnit(idx)">
          <i class="bi bi-pencil-square"></i>
        </button>
        <button type="button" class="delete-btn" (click)="deleteUnit(idx)">
          <i class="bi bi-trash"></i>
        </button>
      </div>
    </div>

    <p>Duration: {{ unit.unit_hours }} minutes</p>

    <div class="saved-topics" *ngIf="unit.topics.length > 0">
      <h5>Topics:</h5>
      <div *ngFor="let t of unit.topics; let i = index">
        <h6>{{ i + 1 }}. {{ t.topic_title }}</h6>
        <ul>
          <li *ngFor="let sub of t.subtopics">{{ sub.subtopic_title }}</li>
        </ul>
      </div>
    </div>
  </section>
</section>

<!-- Add Another Unit Button -->
<div class="add-unit-btn-wrapper" *ngIf="savedUnits.length > 0 && !addUnitVisible">
  <button class="add-unit-btn primary-btn" type="button" (click)="showAddUnit()">
    <i class="bi bi-plus"></i> Add Another Unit
  </button>
</div>

<!-- Add Unit Form -->
<section class="add-unit-container card" *ngIf="addUnitVisible" [formGroup]="unitForm">
  <h2 class="section-title">Add New Unit</h2>

  <div class="form-row">
    <div class="form-group">
      <label>Unit Title <span>*</span></label>
      <input type="text" formControlName="unitTitle" placeholder="e.g., Introduction to Variables" />
    </div>

    <div class="form-group">
      <label>Duration (minutes) <span>*</span></label>
      <input type="text" formControlName="unitHours" placeholder="e.g., 8" />
    </div>
  </div>

  <!-- Topics Section -->
  <section class="topics-section">
    <div class="topics-header">
      <p class="topics-title">Topics</p>
      <button class="add-topic-btn secondary-btn" type="button" (click)="addTopic()">+ Add Topic</button>
    </div>

    <div class="topics-box" formArrayName="topics">
      <p class="no-topics" *ngIf="topics.controls.length === 0">No topics added</p>

      <div class="topic-item card" *ngFor="let topic of topics.controls; let i = index" [formGroupName]="i">
        <div class="topic-header">
          <input type="text" formControlName="title" placeholder="Topic title" />

          <div class="topic-actions">
            <button type="button" (click)="toggleSubtopics(i)">
              <i class="bi"
                [ngClass]="{'bi-chevron-down': !topic.value.showSubtopics, 'bi-chevron-up': topic.value.showSubtopics}"></i>
            </button>
            <button type="button" (click)="deleteTopic(i)">
              <i class="bi bi-trash"></i>
            </button>
          </div>
        </div>

        <!-- Subtopics Section -->
        <div class="subtopics-section" *ngIf="topic.value.showSubtopics" formArrayName="subtopics">
          <div class="subtopic-header">
            <p class="subtopic-title">Subtopics</p>
            <button class="add-subtopic-btn" type="button" (click)="addSubtopic(i)">+ Add Subtopic</button>
          </div>

          <div class="subtopic-list">
            <div class="subtopic-item" *ngFor="let sub of getSubtopics(i).controls; let j = index">
              <input type="text" [formControlName]="j" placeholder="Enter subtopic" class="subtopic-input" />
              <button class="delete-sub-btn" type="button" (click)="deleteSubtopic(i, j)">
                <i class="bi bi-trash"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>

  <div class="btn-container">
    <button class="save-btn primary-btn" type="button" (click)="saveUnit()">
      <i class="bi bi-floppy2-fill"></i> Save Unit
    </button>
  </div>
</section>

<!-- Navigation Buttons -->
<div class="d-flex justify-content-between align-items-center mt-3">
  <button type="button" class="btn-cancel py-2" (click)="goToPrePage()">
    <mat-icon class="icon-middle me-2">chevron_left</mat-icon> Previous
  </button>

  <button type="submit" class="btn-add py-2" (click)="goToNextPage()" [disabled]="isNextDisabled">
    Next <mat-icon class="icon-middle">chevron_right</mat-icon>
  </button>
</div>